import React, {useEffect, useState} from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import {connect} from 'react-redux';
import {Actions as CREATEACCOUNTACTIONS} from 'store/actions/createAccountActions';
import {Actions as PAYMENTACTIONS} from 'store/actions/paymentActions';
import { appUrl } from "../../utils/appHandoff";

const SavePaymentMethodInline = ({
    createAccount,
    fullName,
    email,
    data,
    validateForm,
    onPaymentMethodSaved,
    getStripeIntent,

    userCreated,
    creatingAccount,
    demoAccountCreated,
    stripeIntent,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processingPayment, setProcessingPayment] = useState()

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    if (!validateForm()) {
        console.log('notValidated')
        return;
    }

    const {error: submitError} = await elements.submit();
    if (submitError) {
        // handleError(submitError);
        return;
    } else {
        setProcessingPayment(true)
    }

    createAccount(data);


  };

    useEffect( () => {
      // If the stripe intent is available, attempt to save the payment method
      if (!stripeIntent) return;
      async function attemptPayment() {
        // You can await here
        // Use the SetupIntent to confirm and save the payment method
        const { error, setupIntent } = await stripe.confirmSetup({
          elements,
          clientSecret: stripeIntent,
          confirmParams: {
            return_url: window.location.href,
            // Optionally add billing details here if required
            // For example:
            payment_method_data: {
              billing_details: {
                  name: fullName,
                  email,
              },
            },
          },
          redirect: 'if_required', // Remains inline if no redirection is needed
        });

        if (error) {
          console.error("Error saving payment method:", error);
          // Optionally display error to the user here
        } else {
          // When successful, the setupIntent contains the saved payment method ID
          // Pass it to your callback to save on the backend
          const paymentMethodId = setupIntent.payment_method;
          onPaymentMethodSaved(paymentMethodId);
        }
        // ...
      }
      attemptPayment();

    }, [stripeIntent]);

    useEffect(() => {
        if(userCreated){
            // on user created, get the stripe intent
            getStripeIntent()
        }
    }, [userCreated]);


    useEffect(() => {
        if(demoAccountCreated){
            window.location.href = appUrl();
        }
    }, [demoAccountCreated]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="inline-payment-element" style={{ padding: '10px 0' }}>
        <PaymentElement />
      </div>

        { ((creatingAccount || userCreated || processingPayment) && !demoAccountCreated) ?
          <div className="text-orange-600 text-sm">
            <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            We're creating your Account, please stay on this page until the process completes.
          </div>
            :
          <button
            type="submit"
            disabled={!stripe}
            style={{
              padding: '8px 16px',
              backgroundColor: '#f97316',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Save Payment Method
          </button>
        }
    </form>
  );
};

const mapStateToProps = (state) => {

    // const offerBundle = {
    //   name: "250 Credits",
    //   price: 500,
    //   bonusCredits: "2021 Unlimited ",
    // }

      const createAccount = state && state.createAccount
      let profile = state && state.my && state.my.profile

    return {
        creatingAccount: createAccount.creating,
        error: createAccount.error,
        userCreated: createAccount.userCreated,
        userUpdated: createAccount.userUpdated,
        acLeadCreated: createAccount.acLeadCreated,
        demoAccountCreated: createAccount.demoAccountCreated,
        profile,
        processing: state.authentication.processing,
        stripeIntent: state.payment.stripe.intent && state.payment.stripe.intent.client_secret,
  }
}

const mapDispatchToProps = dispatch => ({
    createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
  getStripeIntent: () => dispatch(PAYMENTACTIONS.getStripeIntent(true)),
  onPaymentMethodSaved: (paymentMethodId) => dispatch(PAYMENTACTIONS.attachPaymentMethod(paymentMethodId)),
  // processStripeCharge: ({paymentIntentID,bundle,customerDetails}) => dispatch(PAYMENTACTIONS.processStripeCharge({paymentIntentID,bundle,customerDetails})),
  // createStripeCharge: (paymentMethodID) => dispatch(PAYMENTACTIONS.createStripeCharge(paymentMethodID)),
  //
  //
  // // getStripePaymentMethods: () => dispatch(PAYMENTACTIONS.getStripePaymentMethods()),
  // clearBundle: () => dispatch(PAYMENTACTIONS.selectBundle(null)),
  // cancelNewCard: () => dispatch(PAYMENTACTIONS.addNewCard(false)),
  // setSavingCard: (status) => dispatch(PAYMENTACTIONS.savingNewCard(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SavePaymentMethodInline)
